import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import urlParser from 'js-video-url-parser';

export const supportedVideoSites = ['youtube', 'vimeo'];

export const videoInfoFromURL = url => {
  const videoInfo = urlParser.parse(url);
  if (!videoInfo) {
    return false;
  }
  const { mediaType, id, provider } = videoInfo;
  if (!(mediaType === 'video' && !supportedVideoSites[provider])) {
    return false;
  }
  return { site: provider, key: id };
};

export const videoInfoToURL = (key, site) => {
  if (!supportedVideoSites.includes(site)) {
    return false;
  }
  const videoInfo = {
    provider: site,
    id: key,
    mediaType: 'video',
  };
  const generatedUrl = urlParser.create({ videoInfo, format: 'embed' });
  return generatedUrl && `https:${generatedUrl}`;
};

@observer
export class MediaInput extends React.Component {
  onBlur = () => {
    const {
      store: { SubmitVideo },
    } = this.props;
    SubmitVideo();
  };

  onKeyDown = e => {
    if ((e.which === 13 || e.which === 8) && e.target.value === '') {
      const {
        store: { SubmitVideo },
      } = this.props;
      e.preventDefault();
      SubmitVideo();
    }
  };

  render() {
    const { store } = this.props;
    const {
      mediaMenuStore: { SetInput, inputValue },
    } = store;
    return (
      <Wrapper>
        <Input
          type='text'
          className='inputNoBorder'
          placeholder='Paste a Youtube or Vimeo link, and press Enter'
          value={inputValue}
          onBlur={this.onBlur}
          onChange={e => SetInput(e.target.value)}
          onKeyDown={this.onKeyDown}
        />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  border-radius: 6px;
  width: 400px;
  &:after {
    content: ' ';
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -10px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent white transparent transparent;
  }
`;

const Input = styled.input`
  border: none;
  overflow: hidden;
  color: ${props => props.theme.color.wfGrey};
  width: 100%;
  height: 100%;
  font-size: 17px;
  padding-left: 10px;
`;

MediaInput.propTypes = {
  store: PropTypes.object,
};
